// Custom hook for Google Analytics page tracking
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../services/analytics';

// Stable, English, non-localised labels used ONLY as the GA page-view label.
// They are deliberately not the user-visible <title>: keeping them constant
// across locales means one GA row per page instead of three.
const getAnalyticsLabel = (pathname) => {
  const labels = {
    '/': 'Home - Taroca Tarot Reading',
    '/love-spread': 'Love Spread - Taroca Tarot Reading',
    '/career-spread': 'Career Spread - Taroca Tarot Reading',
    '/personal-growth-spread': 'Personal Growth Spread - Taroca Tarot Reading',
    '/mental-healing-spread': 'Mental Healing Spread - Taroca Tarot Reading',
    '/general-spread': 'General Spread - Taroca Tarot Reading',
    '/spread-drawing': 'Drawing Cards - Taroca Tarot Reading',
    '/diary': 'Reading Diary - Taroca Tarot Reading',
    '/import': 'Import Reading - Taroca Tarot Reading',
    '/login': 'Login - Taroca Tarot Reading',
    '/profile': 'Profile - Taroca Tarot Reading',
    '/reset-password': 'Reset Password - Taroca Tarot Reading',
  };

  // Handle dynamic routes like /reading/:id
  if (pathname.startsWith('/reading/')) {
    return 'Reading Detail - Taroca Tarot Reading';
  }

  return labels[pathname] || 'Taroca Tarot Reading';
};

// Hook to automatically track page views.
//
// This hook no longer sets document.title. It used to, which meant this
// hardcoded English string overwrote the localised title on every navigation —
// Japanese and Chinese users never saw a translated tab title. The title is now
// owned solely by useSeoMeta.
const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search, getAnalyticsLabel(location.pathname));
  }, [location]);
};

export default usePageTracking;
